import { useQuery } from 'react-query';
import { useLanguage } from 'src/common/hooks';
import { client } from 'src/utils/api-client';
import { EsgStakeholderSurveyMetadataOutSchema } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const useEsgStakeholderSurveyMetadata = () => {
  const url = `/web/esg/v3/stakeholders-survey/metadata`;
  const { language } = useLanguage();
  const queryKey = ['esg', 'survey-metadata', language];
  const query = useQuery(queryKey, () =>
    client
      .get<EsgStakeholderSurveyMetadataOutSchema>(url)
      .then((res) => res.data)
  );
  const metadata = query.data || ({} as EsgStakeholderSurveyMetadataOutSchema);
  return { metadata, ...query };
};
